import { isActiveMembership } from "../../core/membership.core";
import { MembershipPrice, Product } from "../../types/product";
import { useGuru } from "../context/guruContext";

const GURU_FAMILY_MEMBERSHIP_ID = "64f0198546e7d9b2f266b367";

function getProductMembershipPrices(product: Product): MembershipPrice[] {
  const prices = product.membershipPrices ?? [];

  if (product.productType !== "variationParent" || !product.variations?.length) {
    return prices;
  }

  const variationPrices = product.variations.flatMap((variation) => variation.membershipPrices ?? []);
  return [...prices, ...variationPrices];
}

export function ProductItemMembershipDiscountBadge({ product }: { product: Product }) {
  const { profileData } = useGuru();

  const membershipPrices = getProductMembershipPrices(product);
  if (membershipPrices.length === 0) return null;

  const foundGuruMemberhsipPrice = membershipPrices.find(
    (mp) => mp.membership.id === GURU_FAMILY_MEMBERSHIP_ID && mp.price !== null
  );

  if (!foundGuruMemberhsipPrice) return null;
  if (!profileData) return null;

  const activeMembership = profileData.memberships.find(
    (m) => m.id === GURU_FAMILY_MEMBERSHIP_ID && isActiveMembership(m)
  );
  if (!activeMembership) return null;

  return <span className="text-white bg-guru-redOnion inline-block px-2 py-0.5 text-xs rounded-md">Guru Family 優惠!</span>;
}
